<script lang="ts">
import { getWidgetFieldProps } from '@widgets/shared/compositions/field'
import WidgetFieldPhone from '@widgets/shared/components/fields/WidgetFieldPhone.vue'
import { defineComponent, h, type PropType } from '@/composition/vue/compositionApi'
import type { TmCountryCode } from '@/services/types'

export default defineComponent({
  props: {
    countryName: {
      type: String,
      required: true,
    },
    phoneName: {
      type: String,
      required: true,
    },
    availableCountries: {
      type: Array as PropType<TmCountryCode[]>,
      default: () => [],
    },
  },
  setup(props, context) {
    return () => {
      const countryProps = getWidgetFieldProps<TmCountryCode>(props.countryName)
      const phoneProps = getWidgetFieldProps(props.phoneName)
      return h(WidgetFieldPhone, {
        ...context.attrs,
        phoneNumber: phoneProps.modelValue,
        countryCode: countryProps.modelValue,
        availableCountries: props.availableCountries,
        hasError: phoneProps.hasError || countryProps.hasError,
        errorMessage: phoneProps.errorMessage || countryProps.errorMessage,
        readonly: phoneProps.readonly || countryProps.readonly,
        'onUpdate:phone-number': phoneProps['onUpdate:model-value'],
        'onUpdate:country-code': countryProps['onUpdate:model-value'],
        onBlur: () => {
          phoneProps.onBlur()
          countryProps.onBlur()
        },
      })
    }
  },
})
</script>
